export default "__VITE_ASSET__37e08ef5__"